import React from 'react'
import PageUnderConstruction from './PageUnderConstruction'

export default function Articles() {
    return (
        <div data-testid = "articles" className = "component-container">
            Articles
            <PageUnderConstruction />
        </div>
    )
}
